import React from 'react'
import './style.css'

export interface TextFieldProps {
    value?: string;
    className?: string;
}

const TextField = ({ value, className }: TextFieldProps) => {
    return (
        <div className={`text-field-container ${className}`}>
            {value}
        </div>
    );
}

export default TextField